import { effect, inject, Injectable, signal } from '@angular/core';
import { StorageService } from './storage.service';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root',
})
export class RouteParamMaskerService {
  protected readonly storageService = inject(StorageService);
  protected readonly uS = inject(UtilityService);
  protected readonly index = signal<{ [mask: string]: any }>({});
  protected readonly storageKey = 'route-masker';
  constructor() {
    this.index.set(this.getFromLocal() || {});
    effect(() => {
      this.saveToLocal();
    });
  }

  protected saveToLocal() {
    this.storageService.saveItem(this.storageKey, this.index());
  }

  protected getFromLocal() {
    return this.storageService.getItem(this.storageKey);
  }

  protected generateMaskID(): string {
    let mask = this.uS.generateUUID();
    if (this.index()[mask] != null) mask = this.generateMaskID();
    return mask;
  }

  generateMask<T>(value: T): string {
    let mask = this.generateMaskID();
    this.index.update((ind) => ({ ...ind, [mask]: value }));
    return mask;
  }

  getByMask<T>(mask: string) {
    // console.log('endNo',mask)
    const res = this.getFromLocal() || {};
    return res?.[mask] as T;
  }

  removeMask(mask: string) {
    this.index.update((ind) => {
      const newIndex = { ...ind };
      delete newIndex[mask];
      return newIndex;
    });
  }
}
